module.exports = __webpack_public_path__ + "static/media/icon_script_default_player.3b1676bf.png";